import type {
  Configuration,
  CreateOAuthAppRequest,
  CreateSessionRequest,
} from '@repo/api-gw-sdk';
import { AiAgentApi, AiAgentAppName, OauthAppsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

/** ADK app hosting an agent session; each console chat surface has its own. */
export { AiAgentAppName };

export const aiAgents = (httpClient: HttpClient, config: Configuration) => {
  const oauthAppsApi = new OauthAppsApi(config);
  const aiAgentApi = new AiAgentApi(config);

  return {
    useList: () =>
      httpClient.execute(
        oauthAppsApi.listOAuthApps.bind(oauthAppsApi),
        '/oauth-apps',
        ''
      ),
    create: (request: CreateOAuthAppRequest) =>
      oauthAppsApi.createOAuthApp(request),
    getAgentCard: () => aiAgentApi.getAIAgentCard(),
    createSession: (
      projectId: string,
      appName: AiAgentAppName,
      request?: CreateSessionRequest
    ) => aiAgentApi.createAIAgentSession(projectId, appName, request),
    getSession: (
      projectId: string,
      sessionId: string,
      appName: AiAgentAppName
    ) => aiAgentApi.getAIAgentSession(projectId, sessionId, appName),
  };
};
